goog.provide("shadow.js.shim.module$$mui$material$Radio$default");
shadow.js.shim.module$$mui$material$Radio$default = shadow.js.shim.module$$mui$material$Radio.default;
